"use client";

import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegalInformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261931" id="legal-information" className="relative py-24 md:py-32 lg:py-40 bg-background text-foreground overflow-hidden flex items-center justify-center min-h-[50vh]">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/legal_notice_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/legal_notice_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669233/img/legal_notice_background.png-wvc-sizes" alt="Legal Information Background" className="w-full h-full object-cover opacity-20" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/90 to-background"></div>
      </div>

      <div ref={ref} className={`container mx-auto px-4 relative z-10 text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <nav className="flex justify-center items-center space-x-2 text-sm text-muted-foreground mb-8">
          <Link to="/HomePage" className="hover:text-primary transition-colors">
            Startseite
          </Link>
          <ChevronRight className="w-4 h-4 opacity-50" />
          <span className="text-foreground font-medium">Impressum</span>
        </nav>

        <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-sm tracking-wider uppercase bg-primary/10 text-primary font-default">
          Rechtliche Hinweise
        </Badge>

        <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold font-default text-foreground mb-6 tracking-tight">
          Impressum
        </h1>

        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed font-default">
          Hier finden Sie alle gesetzlich vorgeschriebenen Angaben zur Anbieterkennzeichnung sowie wichtige rechtliche Informationen über unser Unternehmen.
        </p>

        <Separator className="w-24 mx-auto bg-primary h-1 rounded-md" />
      </div>
    </section>;
}